import { ProjectSkillEditorPage } from "@/features/projects/project-skill-editor.page";
import { createFileRoute } from "@tanstack/react-router";

type ProjectSkillSearch = {
  /** CR-175: open a platform skill as an unsaved customization draft. */
  customize?: true;
};

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/$skillId",
)({
  // Only an explicit `customize=true` is kept; anything else drops the key
  // (a kept invalid key would break retained search params — CR-144).
  validateSearch: (search: Record<string, unknown>): ProjectSkillSearch =>
    search.customize === true || search.customize === "true" ? { customize: true } : {},
  component: ProjectSkillEditRoute,
});

function ProjectSkillEditRoute() {
  const { skillId } = Route.useParams();
  const { customize } = Route.useSearch();
  return <ProjectSkillEditorPage skillId={skillId} customize={customize ?? false} />;
}
